import { useTranslation } from 'react-i18next';

import { AssetsService } from 'services/AssetsService';

import { quotaI18nKeys } from '../i18n';

import {
  StyledBannerContainer,
  StyledBannerImage,
  StyledBannerSubtitle,
  StyledBannerTextContainer,
  StyledBannerTitle,
} from './styles';

export const NotifyAdminSuccessBanner = () => {
  const { t } = useTranslation();

  return (
    <StyledBannerContainer data-automation="notify-admin-success-banner">
      <StyledBannerImage src={AssetsService.assetUrl('/images/balloons.svg')} alt="balloons" />

      <StyledBannerTextContainer>
        <StyledBannerTitle>{t(quotaI18nKeys.notifyAdminSuccessTitle)}</StyledBannerTitle>
        <StyledBannerSubtitle>{t(quotaI18nKeys.notifyAdminSuccessDescription)}</StyledBannerSubtitle>
      </StyledBannerTextContainer>
    </StyledBannerContainer>
  );
};
